import crypto from 'crypto';
export var sha256Hash = function sha256Hash(str) {
  return crypto.createHash('sha256').update(str).digest('hex');
};
export var sanitizeSources = function sanitizeSources(sources) {
  return sources.map(function (source) {
    var _source$ari;
    return {
      id: (_source$ari = source.ari) !== null && _source$ari !== void 0 ? _source$ari : source.id,
      type: source.type
    };
  });
};